import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PrintRequestsList from './components/PrintRequestsList'

const PrintRequests = () => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Print Requests Management</h3>
          <h3 className="page-subhead subhead">View print requests made by users so far!</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <PrintRequestsList />
        </Col>
      </Row>
    </Container>
  );
};

export default PrintRequests;